import KeywordService from 'src/modules/keyword/keywordService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/store';
import { i18n } from 'src/i18n';

const prefix = 'KEYWORD_FORM';

const keywordFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: keywordFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await KeywordService.find(id);
      }

      dispatch({
        type: keywordFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: keywordFormActions.INIT_ERROR,
      });

      getHistory().push('/keyword');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: keywordFormActions.CREATE_STARTED,
      });

      await KeywordService.create(values);

      dispatch({
        type: keywordFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.keyword.create.success'),
      );

      getHistory().push('/keyword');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: keywordFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, _getState) => {
    try {
      dispatch({
        type: keywordFormActions.UPDATE_STARTED,
      });

      await KeywordService.update(id, values);

      dispatch({
        type: keywordFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.keyword.update.success'),
      );

      getHistory().push('/keyword');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: keywordFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default keywordFormActions;
